export default {
    string_to_slug (str) {
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();
      
        // remove accents, swap ñ for n, etc
        var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
        var to   = "aaaaeeeeiiiioooouuuunc------";
        for (var i=0, l=from.length ; i<l ; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }
    
        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-'); // collapse dashes
    
        return str;
    },
    getStatusText (minStatusId) {

    
    // Mapeamento dos IDs de status
      const statusMap = {
        13: 'Pedido cancelado',
        14: 'Em planejamento',
        15: 'Resposta de cotação pendente',
        16: 'Aguardando confirmação',
        17: 'Pedido rejeitado',
        18: 'Aguardando aprovação do cliente',
        19: 'Aguardando pagamento',
        20: 'Aguardando pagamento',
        21: 'Aguardando envio do conteúdo',
        22: 'Pendente aprovação de conteúdo',
        23: 'Aguardando adequação de conteúdo',
        24: 'Aguardando início de veiculação',
        25: 'Em veiculação',
        26: 'Falha na veiculação',
        27: 'Veiculação concluída',
        28: 'Campanha aprovada - aguarde PI(s)',
        29: 'Pedido de Inserção aprovado',
        30: 'Pedido de Inserção reprovado',
        31: 'Pendente aprovação do(s) PI(s)',
        32: 'Aguardando pagamento',
        33: 'Aguardando pagamento'
      };
      const statusQuotationMap = {
        quotation_accepted: "Cotação respondida",
        add_quotation: "Cotação iniciada",
        created: "Citação criada",
        reservation_accepted: "Reserva confirmada",
        quotation_free: "Bonificado",
        cancelled: "Cotação cancelada",
        waiting_payment: "Cotação aprovada - em aprovação de pagamento",
        change_grid_version: "Campanha em alteração"

      }
      if(isNaN(minStatusId))
          return statusQuotationMap[minStatusId];
      else
          return minStatusId ? statusMap[minStatusId] || `${minStatusId}` : 'Sem status';
      
    },

    getStatusColor(minStatusId) {
      
      const colorMap = {
        13: '#dc3545',  // Vermelho - Pedido cancelado
        14: '#FFFF00',  // Amarelo - Em planejamento
        15: '#FFFF00',  // Amarelo - Resposta de cotação pendente
        16: '#FFFF00',  // Amarelo - Aguardando confirmação
        17: '#dc3545',  // Vermelho - Pedido rejeitado
        18: '#ff8c00',  // Laranja - Aguardando aprovação
        19: '#ff8c00',  // Laranja - Aguardando pagamento
        20: '#ff8c00',  // Laranja - Aguardando pagamento
        21: '#ff8c00',  // Laranja - Aguardando envio do conteúdo
        22: '#FFFF00',  // Amarelo - Pendente aprovação de conteúdo
        23: '#dc3545',  // Vermelho - Aguardando adequação de conteúdo
        24: '#17a2b8',  // Azul - Aguardando início de veiculação
        25: '#28a745',  // Verde - Em veiculação
        26: '#FFFF00',  // Amarelo - Falha na veiculação
        27: '#28a745',  // Verde - Veiculação concluída
        28: '#FFFF00',  // Amarelo - Campanha aprovada - aguarde PI(s)
        29: '#28a745',  // Verde - Pedido de Inserção aprovado
        30: '#dc3545',  // Vermelho - Pedido de Inserção reprovado
        31: '#FFFF00',  // Amarelo - Pendente aprovação do(s) PI(s)
        32: '#ff8c00',  // Laranja - Aguardando pagamento
        33: '#ff8c00'   // Laranja - Aguardando pagamento
      };

      const statusQuotationMap = {
        quotation_accepted: "#17a2b8",
        add_quotation: "#ff8c00",
        created: "#FFFF00",
        reservation_accepted: "#28a745",
        quotation_free: "#28a745",
        cancelled: "#dc3545",
        waiting_payment: "#17a2b8",
        change_grid_version: "#ff8c00"

      }

      if(isNaN(minStatusId))
          return statusQuotationMap[minStatusId];
      else
          return minStatusId ? colorMap[minStatusId] || '#6c757d' : '#6c757d'; // Cinza como padrão



    },
     accentsTidy(s) {
        var r = s.toLowerCase();
        r = r.replace(new RegExp("\\s", 'g'), "");
        r = r.replace(new RegExp("[àáâãäå]", 'g'), "a");
        r = r.replace(new RegExp("æ", 'g'), "ae");
        r = r.replace(new RegExp("ç", 'g'), "c");
        r = r.replace(new RegExp("[èéêë]", 'g'), "e");
        r = r.replace(new RegExp("[ìíîï]", 'g'), "i");
        r = r.replace(new RegExp("ñ", 'g'), "n");
        r = r.replace(new RegExp("[òóôõö]", 'g'), "o");
        r = r.replace(new RegExp("œ", 'g'), "oe");
        r = r.replace(new RegExp("[ùúûü]", 'g'), "u");
        r = r.replace(new RegExp("[ýÿ]", 'g'), "y");
        r = r.replace(new RegExp("\\W", 'g'), "");
        return r;
    },
    mediaTypeLogo(value) {
        switch (value) {
            case "Televisão": return 'tv'
            case "Rádio": return 'radio'
            case "Mídia Exterior": return "ooh"
            case "Online": return "online"
            case "Jornal": return "jornal"
            case "Revista": return "Revista"
            case "Cinemas": return "cinema"
            default: return "ooh"
        }
    },
    colorMediaType(mediaType) {
        const colorsMT = {
            "Rádio": "#3fb1e7",
            "Televisão": "#20cbc2",
            "Mídia Exterior": "#074d81",
            "Cinema": "#f97b17",
            "Revista": "#cb1324",
            "Jornal": "#f9bb04",
            "Online": "#c068a8"
        }
        return colorsMT[mediaType]
    },
    formatMediaType(mediaType, fontsize = 12, heighticon = 12, onlyLogo = false, breakLine = false) {
        const colorsMT = {
            "Rádio": "#3fb1e7",
            "Televisão": "#20cbc2",
            "Mídia Exterior": "#074d81",
            "Cinema": "#f97b17",
            "Revista": "#cb1324",
            "Jornal": "#f9bb04",
            "Online": "#c068a8"
        }
        const icons = {
            'Mídia Exterior': 'ooh',
            'Cinema': 'cinema',
            'Revista': 'revista',
            'Jornal': 'jornal',
            'Rádio': 'radio',
            'Televisão': 'tv',
            'Online': 'online'
        }
        if (onlyLogo) {
            if (Object.prototype.hasOwnProperty.call(colorsMT, mediaType)) {
                return 'https://lion-web-site.s3.amazonaws.com/logos/email/ico-' + icons[mediaType] + '.svg';
            } else {
                return 'https://lion-web-site.s3.amazonaws.com/public/img.svg">';
            }
        } else {
            let center = breakLine ? 'text-align: center' : ''
            let breakP = breakLine ? '<br>' : '';
            if (Object.prototype.hasOwnProperty.call(colorsMT, mediaType)) {
                return `<span style="color:${colorsMT[mediaType]}; font-size: ${fontsize}px; ${center}"><img src="https://lion-web-site.s3.amazonaws.com/logos/email/ico-${icons[mediaType]}.svg" alt="" height="${heighticon}" width="28"> ${breakP} ${mediaType}</span>`;
            } else {
                return `<span style="font-size:${fontsize}px; ${center}">${breakP} ${mediaType}</span>`;
            }
        }
    },
    setCookie(cname, cvalue, days = 5) {
        var d = new Date();
        d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    deleteCookie(cname) {
        return document.cookie =`${cname}=; path=/; domain=.${window.location.host.toString()}; expires=${new Date(0).toUTCString()}`
            
    },
    isDocument(value) {
        value = value.replace(/[^0-9]/g, "");
        switch (value.length) {
            case 11:
                return this.isCPF(value)
            case 14:
                return this.isCNPJ(value)
            default:
                return false
        }
    },
    isCNPJ(value) {
        let cnpj = value.replace(/[^\d]+/g, '');

        if (cnpj == '') return false;

        if (cnpj.length != 14)
            return false;

        // Elimina CNPJs invalidos conhecidos
        if (cnpj == "00000000000000" ||
            cnpj == "11111111111111" ||
            cnpj == "22222222222222" ||
            cnpj == "33333333333333" ||
            cnpj == "44444444444444" ||
            cnpj == "55555555555555" ||
            cnpj == "66666666666666" ||
            cnpj == "77777777777777" ||
            cnpj == "88888888888888" ||
            cnpj == "99999999999999")
            return false;

        // Valida DVs
        let tamanho = cnpj.length - 2
        let numeros = cnpj.substring(0, tamanho);
        let digitos = cnpj.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                pos = 9;
        }
        let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0))
            return false;

        tamanho = tamanho + 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1))
            return false;

        return true;
    },
    isCPF(value) {
        value = value.replace(/[^0-9]/g, "")
        if (value.length != 11 ||
            value == "00000000000" ||
            value == "11111111111" ||
            value == "22222222222" ||
            value == "33333333333" ||
            value == "44444444444" ||
            value == "55555555555" ||
            value == "66666666666" ||
            value == "77777777777" ||
            value == "88888888888" ||
            value == "99999999999")
            return false;

        let add = 0;

        for (let i = 0; i < 9; i++)
            add += parseInt(value.charAt(i)) * (10 - i);
        let rev = 11 - (add % 11);
        if (rev == 10 || rev == 11)
            rev = 0;
        if (rev != parseInt(value.charAt(9)))
            return false;
        add = 0;
        for (let i = 0; i < 10; i++)
            add += parseInt(value.charAt(i)) * (11 - i);
        rev = 11 - (add % 11);
        if (rev == 10 || rev == 11)
            rev = 0;
        if (rev != parseInt(value.charAt(10)))
            return false;
        return true;
    },


}